export const chatContainerStyles = () => theme => ({
  px: 5,
  width: '100%',
  mb: 6,
  display: 'flex',

  [theme.breakpoints.up('sm')]: {
    mb: 0,
  },

  [theme.breakpoints.down('sm')]: {
    px: 3,
  },
});

export const avatarContainerStyles = {
  pr: 1,
  pt: 0.5,
};

export const messageContainerStyles = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
};
